export var PROGRESS_STEPPER_LABEL_APPEARANCES = Object.freeze({
  ALL: 'all',
  CURRENT: 'current',
  NONE: 'none'
});